import './component.css';
import { useTranslation } from 'react-i18next';
import { Divider, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { Fragment } from 'react';
import _ from 'lodash';

const NokDemographic = ({ patient }) => {
    const { nextOfKins = [] } = patient;
    const { t } = useTranslation();

    const renderAddress = (address) => {
        let text = '';

        if (address) {
            text = address.postalCode ? `${address.postalCode}\n` : '-';
            const addressLines = address.addressLines || address.lines;
            if (addressLines && addressLines.length > 0) {
                addressLines.forEach((element) => {
                    text += element ? `${element}\n` : '';
                });
            }
        }

        return (
            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Address')}`}
                </Typography>

                {address?.type && (
                    <Typography variant="body1" className="body">
                        {t('Type')}: {address.typeName || '-'}
                    </Typography>
                )}

                <Typography variant="body1" className="body" style={{ whiteSpace: 'pre-wrap' }}>
                    {text || '-'}
                </Typography>
            </Grid>
        );
    };

    const renderNok = (nok) => {
        if (!nok) return null;

        return (
            <Fragment key={nok?.firstName + nok?.familyName + nok.startDate}>
                <Grid item xs={12} className="container-grid">
                    <Typography variant="body1" fontWeight={800}>
                        {nok?.relationship?.__description || 'UNK'}
                    </Typography>

                    <Divider style={{ marginBottom: 10 }} />
                </Grid>

                <Grid item xs={3} className="container-grid">
                    <Typography variant="body1" className="title">
                        {t('Name')}
                    </Typography>

                    <Typography variant="body1" className="body">
                        {`${nok?.firstName || ''} ${nok?.familyName || ''}`}
                    </Typography>
                </Grid>

                <Grid item xs={3} className="container-grid">
                    <Typography variant="body1" className="title">
                        {t('Role')}
                    </Typography>

                    <Typography variant="body1" className="body">
                        {nok?.relationship?.__description ? _.startCase(nok?.relationship?.__description?.toLowerCase()) : 'UNK'}
                    </Typography>
                </Grid>

                <Grid item xs={3} className="container-grid">
                    <Typography variant="body1" className="title">
                        {t('Phone Number (Home)')}
                    </Typography>

                    <Typography variant="body1" className="body">
                        {nok?.phoneNumber || '-'}
                    </Typography>
                </Grid>

                <Grid item xs={3} className="container-grid">
                    <Typography variant="body1" className="title">
                        {t('Phone Number (Work)')}
                    </Typography>

                    <Typography variant="body1" className="body">
                        {nok?.businessPhoneNumber || '-'}
                    </Typography>
                </Grid>

                {renderAddress(nok?.address)}
            </Fragment>
        );
    };

    return (
        <Grid container spacing={1} columns={9} className="container" alignContent="flex-start">
            {nextOfKins?.map((nok) => renderNok(nok))}

            {(!nextOfKins || nextOfKins?.length === 0) && (
                <Typography variant="body1" className="title" style={{ marginLeft: 10, marginTop: 10 }}>
                    {t('No Next of Kin Information')}
                </Typography>
            )}
        </Grid>
    );
};

export default React.memo(NokDemographic);
